import com.cybergstudios.rtc.engine.EngineBuilder
import kotlinx.browser.window

fun main() {
    window.onload = {
        EngineBuilder.build().loop()
    }
}
